/**
 * Labstep
 *
 * @module components/File/Filter/Pane
 * @desc Filter pane for file
 */

import { FileFilterExtensionList } from 'labstep-web/components/File/Filter/Extension/List';
import { FilterPane } from 'labstep-web/components/Filter/Pane';
import { Filter } from 'labstep-web/constants/filters';
import { ICONS } from 'labstep-web/constants/icons';
import type React from 'react';

export const FileFilterPane: React.FC = () => (
  <FilterPane
    filters={[Filter.created_by]}
    entityName="file"
    extraFilters={<FileFilterExtensionList />}
    icon={ICONS.file.primary}
    text="Files"
    filterCreatedByText="Uploaded by"
  />
);
